/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step6_NameInputs */

const en_dr_step6_name = /** @type {(inputs: Dr_Step6_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 · Formulate`)
};

const id_dr_step6_name = /** @type {(inputs: Dr_Step6_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 · Rumuskan`)
};

/**
* | output |
* | --- |
* | "6 · Formulate" |
*
* @param {Dr_Step6_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step6_name = /** @type {((inputs?: Dr_Step6_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step6_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step6_name(inputs)
	return en_dr_step6_name(inputs)
});